import { render, staticRenderFns } from "./ChargesTab.vue?vue&type=template&id=696e2800&scoped=true&"
import script from "./ChargesTab.vue?vue&type=script&lang=js&"
export * from "./ChargesTab.vue?vue&type=script&lang=js&"
import style0 from "./ChargesTab.vue?vue&type=style&index=0&id=696e2800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e2800",
  null
  
)

export default component.exports